import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link, useNavigate } from "react-router-dom";
import {
  getAllIndustryDetailslist,
  getActiveBusinessUnit,
} from "../../../service/BusinessUnit/BusinessUnitService";
import { getAllDepartmentDetailslist } from "../../../service/Department/DepartmentService";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const Businessunit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [industryList, setAllIndustryList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [search, setSearch] = useState("");
  const [departmentList, setAllDepartmentList] = useState([]);
  const [myArrayDepartment, setMyArrayDepartment] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isActive, setActive] = useState("false");
  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = industryList.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(industryList?.length / PER_PAGE);

  const handleToggle = (id, isActive) => {
    setIsLoading(true);
    getActiveBusinessUnit("BusinessUnit", id, isActive ? false : true, (r) => {
      console.log(r, "response");
      if (r.success === true) {
        getIndustryDataList();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        // toast.error(r.message)
      }
    });
  };
  useEffect(() => {
    getIndustryDataList();
  }, []);

  async function getIndustryDataList() {
    setIsLoading(true);
    getAllIndustryDetailslist(search, department).then(function (result) {
      console.log(result.data, "datadatadatadatada");
      const response = result.data;
      console.log(response, "rrrr");
      setAllIndustryList(response.data);
      setIsLoading(false);
    });
  }

  // console.log(industryList, "industryList")

  const onSearch = (e) => {
    setIsLoading(true);
    setSearch(e.target.value);
    getAllIndustryDetailslist(e.target.value, department).then(function (
      result
    ) {
      console.log(result.data, "datadatadatadatada");
      const response = result.data;
      console.log(response, "rrrr");
      setAllIndustryList(response.data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getDepartmentDataList();
  }, []);

  async function getDepartmentDataList() {
    setIsLoading(true);
    getAllDepartmentDetailslist(search).then(function (result) {
      // console.log(result.data, "datadatadatadatada")
      const response = result.data;
      console.log(response, "rrrr");
      setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  }

  // const onDepartment = (e) => {
  //   setDepartment(e.target.value);
  //   getAllIndustryDetailslist(
  //     search,
  //     e.target.value ? [e.target.value] : []
  //   ).then(function (result) {
  //     console.log(result.data, "datadatadatadatada");
  //     const response = result.data;
  //     console.log(response, "rrrr");
  //     setAllIndustryList(response.data);
  //   });
  // };

  const _RESET = (e) => {
    setIsLoading(true);
    e.preventDefault();
    getAllIndustryDetailslist("", []).then(function (result) {
      const response = result.data;
      setAllIndustryList(response.data);
      setSearch("");
      setDepartment("");
      setIsLoading(false);
    });
  };

  const departmentDrop = departmentList?.map((deptRow, index) => ({
    // <option value={roleRow.id}>{roleRow.name}</option>
    value: deptRow.id,
    label: deptRow.name,
  }));

  const onDepartment = (department) => {
    setIsLoading(true);
    setMyArrayDepartment([]);
    department?.map((d) => {
      if (myArrayDepartment.includes(d?.value)) {
        setMyArrayDepartment(myArrayDepartment);
      } else {
        myArrayDepartment.push(d?.value);
        setMyArrayDepartment(myArrayDepartment);
      }
    });
    setDepartment(department);
    const labelsArray = department.map((item) => item.label);
    getAllIndustryDetailslist(search, labelsArray || []).then(function (
      result
    ) {
      const response = result.data;
      console.log(response, "rrrr");
      setAllIndustryList(response.data);
      setIsLoading(false);
    });
  };

  return (
    <div className="container-fluid">
      <div className="dbMain businessUnit">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/dashboard"
            breadcm={`${t("configuration")} > `}
            title={t("business_units")}
            description=""
          />
          <div className="commonBase">
            <div className="dbtableTop">
              <button className="commonButton">
                <Link to="/addbusinessunit">
                  <i className="fa-solid fa-plus"></i> {t("add_business_unit")}
                </Link>
              </button>
              &nbsp;
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("search")}
                  onChange={onSearch}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <div className="dbtableSrchbg" style={{ fontSize: "smaller" }}>
                <Select
                  id="Department"
                  placeholder={t("select_departments")}
                  isMulti
                  options={departmentDrop}
                  value={department}
                  onChange={onDepartment}
                  style={{ minWidth: "170px" }}
                />
                &nbsp;
                <button className="commonButton" onClick={_RESET}>
                  {t("reset")}
                </button>
              </div>
            </div>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("business_unit_header")}</th>
                    <th>{t("short_name")}</th>
                    <th>{t("identification_number")}</th>
                    <th>{t("accounting_keys")}</th>
                    <th>{t("country")}</th>
                    <th>{t("city")}</th>
                    <th>{t("zip_code")}</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}
                {currentPageData?.map((ind, index) => (
                  <tbody key={index}>
                    <tr className={ind?.isActive ? null : "inactive"}>
                      <td data-label={t("business_unit_header")}>
                        <Link
                          to={`/businessunitdetl?id=${ind?.id}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {ind?.name}
                        </Link>
                      </td>
                      <td data-label={t("short_name")}>
                        <Link
                          to={`/businessunitdetl?id=${ind?.id}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {ind?.shortName}
                        </Link>
                      </td>
                      <td data-label={t("bu_identification_no")}>
                        <Link
                          to={`/businessunitdetl?id=${ind?.id}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {ind?.buIdentificationNumber}
                        </Link>
                      </td>
                      <td data-label={t("bu_gl_key")}>
                        <Link to={`javascript:void(0)`}>
                          {ind?.accountingKey}
                        </Link>
                      </td>
                      <td data-label={t("country")}>
                        <Link to={`javascript:void(0)`}>{ind?.country}</Link>
                      </td>
                      <td data-label={t("city")}>
                        <Link to={`javascript:void(0)`}>{ind?.city}</Link>
                      </td>
                      <td data-label={t("zip_code")}>
                        <Link to={`javascript:void(0)`}>{ind?.zipcode}</Link>
                      </td>
                      <td data-label={t("action")}>
                        <button
                          onClick={() => handleToggle(ind?.id, ind?.isActive)}
                          className="beye"
                        >
                          <i className="fa-light fa-eye"></i>
                          <i className="fa-light fa-eye-slash"></i>
                        </button>
                      </td>
                      <td data-label="">
                        <span className="editIcon">
                          <Link to={`/editbusinessunit?id=${ind?.id}`}>
                            <i className="fa-light fa-pen"></i>
                          </Link>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={t("previous")}
                nextLabel={t("next")}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Businessunit;
